import { styled } from '@mui/material/styles';

// HorizontalDivider component
export const HorizontalDivider = styled('div')({
  borderTop: '2px solid #ccc',
  margin: '10px auto 0px',
  width: '90%',
});
